import { useIsHostedInBrowser } from "@modules/Jupiter";
import { useViewModelInstance, hasViewModelInstance } from "./MarketplaceViewModelStore";

const REQUESTED_CATEGORY_KEY = 'request-marketplace-category';

/**
 * Adds a localstorage item for the category ID that will be read when marketplace opens, to start on that category
 * @param categoryId 
 */
export function requestMarketplaceCategory( group?: string | null, categoryId?: string | null )
{
    if( group != null || categoryId != null )
    {
        localStorage.setItem( REQUESTED_CATEGORY_KEY, JSON.stringify( { categoryId, group } ) ); // remembers the category between page loads
        return;
    }
    localStorage.removeItem( REQUESTED_CATEGORY_KEY );
}

/**
 * Gets the request marketplace category or null if none was defined
 * @returns 
 */
export function useGetRequestedMarketplaceCategory() : { group?: string | null, categoryId?: string | null } | undefined
{

    const category = localStorage.getItem( REQUESTED_CATEGORY_KEY ) ?? undefined;
    if( category )
    {
        return JSON.parse( category );
    }
    return undefined;

}

/**
 * Removes the requested marketplace category from localstorage
 */
export async function resetRequestedMarketplaceCategory( clearMarketplaceViewModel: boolean = true )
{
    
    if( localStorage.getItem( REQUESTED_CATEGORY_KEY ) == null ) return;
    localStorage.removeItem( REQUESTED_CATEGORY_KEY );
    
    if( clearMarketplaceViewModel == false ) return;
    
    const isInBrowser = useIsHostedInBrowser();
    const hasMarketplaceViewModelInstance = hasViewModelInstance();
    if( isInBrowser && hasMarketplaceViewModelInstance )
    {
        const marketplace = await useViewModelInstance();
        marketplace.reset();
    }
}